import { useTranslation } from 'react-i18next';
import { Text } from '@lili/lili-frontend-common';
import { ReactComponent as GreenCheckIcon } from '@Assets/icons/green-check-icon.svg';

export const RegisteredAddressExplanation = () => {
  const { t } = useTranslation();
  return (
    <div className='mb-[24px] flex flex-col gap-[8px]'>
      <Text.H10 className='text-text-main-secondary'>
        {t('pages.registeredAddress.explanation')}
      </Text.H10>
      <div className='flex items-start gap-[8px]'>
        <GreenCheckIcon className='shrink-0' />
        <Text.H10 className='text-text-main-secondary'>
          {t('pages.registeredAddress.raAllowed')}
        </Text.H10>
      </div>
      <div className='flex items-start gap-[8px]'>
        <GreenCheckIcon className='shrink-0' />
        <Text.H10 className='text-text-main-secondary'>
          {t('pages.registeredAddress.billingNote')}
        </Text.H10>
      </div>
    </div>
  );
};
